var React = require('react');
var mui = require('material-ui');
var withMuiTheme = require('../decorators/withMuiTheme').default;
var DialogMixin = require('lore-hook-dialogs-material-ui/lib/mixins/DialogMixin');
var PayloadStates = require('../constants/PayloadStates');

module.exports = withMuiTheme(React.createClass({
  displayName: 'SetupFailure',

  mixins: [DialogMixin],

  propTypes: {
    server: React.PropTypes.object.isRequired
  },

  render: function() {
    var server = this.props.server;
    var actions = [
      <mui.FlatButton
        label='Close'
        primary={true}
        onTouchTap={this.onCancel}
      />
    ];

    return (
      <mui.Dialog
        title='Connection Issues Found'
        modal={false}
        open={this.state.isOpen}
        actions={actions}
        onRequestClose={this.onCancel}
        contentStyle={{maxWidth: '600px'}}
      >
        <div style={{width: '100%', margin: 'auto'}}>
          <div className="dialog-text">
            Uh oh, looks like we <strong>could not connect to the test server</strong>.
          </div>
          <div className="dialog-text">
            To better assist you, please send the following message to CyVerse Support at <a href="mailto:support@cyverse.org">support@cyverse.org</a>.
          </div>
          <div className="dialog-text">
            <div className="dialog-text-message">
              ******* BEGIN MESSAGE *******
            </div>
            <div className="dialog-text-message">
              {window.USER_IP_ADDRESS ? (
                'Test performed from IP address ' + window.USER_IP_ADDRESS
              ) : (
                'Could not detect IP address'
              )}
            </div>
            <div className="dialog-text-message">
              Failed to connect to the test server on port {server.id}
            </div>
            <div className="dialog-text-message">
              ******** END MESSAGE ********
            </div>
          </div>
        </div>
      </mui.Dialog>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/dialogs/SetupFailure.js